import RequestPrescreenerBaseCategoryController from './prescreener--base-category';

export default class RequestPrescreenerReasonForCare extends RequestPrescreenerBaseCategoryController {}
